import React, { useState } from 'react';
import Radio from '@material-ui/core/Radio';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@material-ui/core';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
function ExportDialog({ exportModal, toggleModalFn, exportFormReport }) {
    const [selectedValue, setSelectedValue] = useState('both');
    const handleChange = (event) => {
        setSelectedValue(event.target.value);
    };
    return (
        <>
            <Dialog
                open={true}
                // onClose={toggleModalFn}
            >
                <DialogTitle id="scroll-dialog-title">
                    <h5 style={{ fontFamily: 'Conv_IBMPlexSans-Medium', fontWeight: 500 }}> {exportModal?.title || "Physical Review Export"} </h5>
                </DialogTitle>
                <DialogContent dividers={true}>
                    <RadioGroup aria-label="export" name="export" value={selectedValue} onChange={handleChange}>
                        <FormControlLabel value="installed" control={<Radio color="primary" checked={selectedValue === 'installed'} />} label="Installed Engine" />
                        <FormControlLabel value="removed" control={<Radio color="primary" checked={selectedValue === 'removed'} />} label="Removed Engine" />
                        <FormControlLabel value="both" control={<Radio color="primary" checked={selectedValue === 'both'} />} label="Both" />
                    </RadioGroup>
                </DialogContent>
                <DialogActions>
                    <Button onClick={toggleModalFn} color="primary" size='small' variant='outlined'>Cancel</Button>
                    <Button onClick={() => exportFormReport(exportModal, selectedValue)} color="primary" size='small' variant='contained'>Export</Button>
                </DialogActions>

            </Dialog>
        </>
    )
}

export default ExportDialog